import { useEffect } from 'react';
import { useToastStore, type Toast } from '../state/toastStore.ts';
import { Icon } from './icons/index.tsx';
import styles from './Toaster.module.css';

const LIFETIME_MS = 4200;

function ToastItem({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss);
  useEffect(() => {
    const id = setTimeout(() => {
      dismiss(toast.id);
    }, LIFETIME_MS);
    return () => {
      clearTimeout(id);
    };
  }, [dismiss, toast.id]);
  return (
    <div className={[styles['toast'], styles[toast.tone]].join(' ')}>
      <Icon
        name={toast.tone === 'danger' ? 'close' : toast.tone === 'success' ? 'check' : 'spark'}
      />
      <span>{toast.text}</span>
    </div>
  );
}

/** Polite live region that shows transient messages. Mount once near the app root. */
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <div className={styles['region']} role="status" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
}
